<template>
  <BField
    label="Nombre del cliente"
    label-for="customer-name"
  >
    <BAutocomplete
      id="customer-name"
      ref="input"
      name="customer-name"
      placeholder="Alonso Navarro"
      field="name"
      type="name"
      icon="account"
      :value="value"
      :data="customers"
      :loading="loading"
      :required="required"
      :disabled="disabled"
      open-on-focus
      @typing="getCustomers"
      @input="onInput"
      @select="onSelect"
    >
      <template slot-scope="props">
        <div class="columns is-multiline">
          <div class="column is-2">
            email:
          </div>
          <div class="column is-10">
            {{ props.option.email }}
          </div>
          <div class="column is-2">
            name
          </div>
          <div class="column is-10">
            {{ props.option.name }}
          </div>
          <div class="column is-2">
            RFC:
          </div>
          <div class="column is-10">
            {{ props.option.rfc }}
          </div>
        </div>
      </template>
    </BAutocomplete>
  </BField>
</template>

<script>
import debounce from 'lodash/debounce';
import { mapState } from 'vuex';
import moment from 'moment';

export default {
  name: 'SearcherByName',
  props: {
    required: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: mapState({
    name: state => state.customers.name,
    customers: state => state.customers.list,
  }),
  watch: {
    name() {
      this.checkHtmlValidity();
    },
  },
  methods: {
    checkHtmlValidity() {
      setTimeout(() => {
        if (this.$refs.input) this.$refs.input.checkHtml5Validity();
      }, 10);
    },
    onInput(value) {
      this.$store.commit('customers/setValue', { accessor: 'name', value });
    },
    getCustomers: debounce(async function getCustomers(name) {
      if (name.length > 3) {
        this.loading = true;

        try {
          await this.$store.dispatch('customers/getAll', { size: 50, page: 1, name });
        } catch (error) {
          // eslint-disable-next-line
          console.error(error);
        }

        this.loading = false;
      }
    }, 400),
    onSelect(option = {}) {
      if (option) {
        const {
          name,
          email,
          rfc,
          companyName,
          creditDays,
          creditLimit,
          debts,
          debtsExpired,
          id,
          zipCode,
          taxRegime,
        } = option;

        const Days = creditDays > 0 ? creditDays : 1;
        const expirationDate = moment().add(Days, 'days').toDate();

        this.$store.commit('customers/setValues', {
          name,
          email,
          rfc,
          companyName,
          creditDays,
          creditLimit,
          debts,
          debtsExpired,
          id,
        });

        this.$store.commit('users/setValues', {
          name,
          email,
          rfc,
          companyName,
        });

        this.$store.commit('invoice/setValues', {
          receiverName: companyName,
          receiverRfc: rfc,
          receiverZipCode: zipCode,
          receiverTaxRegime: taxRegime,
          'operation.expirationDate': expirationDate,
          'operation.name': name,
          'operation.email': email,
        });

        this.$emit('select', option);

        setTimeout(() => {
          this.$refs.input.checkHtml5Validity();
        }, 10);
      }
    },
  },
};
</script>

<style scoped>
.column {
  padding: 0.15rem 0.25rem;
}
</style>
